
(function storageDefinition() {
    'use strict';
    angular.module('Entities')
        .service('storageService', [
            'authExtend', function storageService(auth) {
                var stateBackFind = undefined;
                var advancedFilter = {};
                var advancedContainerFilter = {};
                var mydocumentFilter = {};
                var mycontainerFilter = {};
                var imagesProcessFilter = {};
                var calendarFilter = {};
                var userFilter = {};
                var that = this;
                var userQuery = {};
                var notifFilter = {};
                var authNotifFilter = {};
                var searchBarFilter = {};
                var dtAllcheckedFilter = true;
                var ctAllcheckedFilter = true;
                var auditFilter = {};
                var auditPagination = {};
                var TYCPagination = {};
                var containerTypeFilter = {};

                auth.onIdentityChanged(function () {
                    that.init();
                });

                this.setDocumentFilter = function (filters) {
                    advancedFilter = angular.copy(filters);
                }

                this.setContainerFilter = function (filters) {
                    advancedContainerFilter = angular.copy(filters);
                }

                this.setMyDocumentFilter = function (filters) {
                    mydocumentFilter = angular.copy(filters);
                }

                this.setMyContainerFilter = function (filters) {
                    mycontainerFilter = angular.copy(filters);
                }

                this.setImagesProcessFilter = function (filters) {
                    imagesProcessFilter = angular.copy(filters);
                }

                this.setUserFilter = function (filters) {
                    userFilter = angular.copy(filters);
                }

                this.setCalendarFilter = function (filters) {
                    calendarFilter = angular.copy(filters);
                }

                this.setStateBackFind = function (state) {
                    stateBackFind = angular.copy(state);
                }

                this.setNotifFilter = function (filters) {
                    notifFilter = angular.copy(filters);
                }

                this.setAuthNotifFilter = function (filters) {
                    authNotifFilter = angular.copy(filters);
                }

                this.setUserQuery = function (uq) {
                    userQuery = angular.copy(uq);
                }

                this.setSearchBarFilter = function (filters) {
                    searchBarFilter = filters;
                }

                this.setDtAllChecked = function (filters) {
                    dtAllcheckedFilter = filters;
                }

                this.setCtAllChecked = function (filters) {
                    ctAllcheckedFilter = filters;
                }

                this.setAuditFilter = function (filters) {
                    auditFilter = angular.copy(filters);
                }

                this.setAuditPagination = function (filters) {
                    auditPagination = angular.copy(filters);
                };

                this.setTYCPagination = function (filters) {
                    TYCPagination = angular.copy(filters);
                };

                this.setContainerTypeFilter = function (filters) {
                    containerTypeFilter = angular.copy(filters);
                };

                this.getDocumentFilter = function () {
                    return angular.copy(advancedFilter);
                }

                this.getMyDocumentFilter = function () {
                    return angular.copy(mydocumentFilter);
                }

                this.getMyContainerFilter = function () {
                    return angular.copy(mycontainerFilter);
                }

                this.getContainerFilter = function () {
                    return angular.copy(advancedContainerFilter);
                }

                this.getImagesProcessFilter = function (filters) {
                    return angular.copy(imagesProcessFilter);
                }

                this.getUserFilter = function (filters) {
                    return angular.copy(userFilter);
                }

                this.getCalendarFilter = function (filters) {
                    return angular.copy(calendarFilter);
                }

                this.getStateBackFind = function () {
                    return stateBackFind;
                }

                this.getNotifFilter = function () {
                    return angular.copy(notifFilter);
                }

                this.getAuthNotifFilter = function () {
                    return angular.copy(authNotifFilter);
                }

                this.getUserQuery = function () {
                    return angular.copy(userQuery);
                }

                this.getSearchBarFilter = function (filters) {
                    return angular.copy(searchBarFilter);
                }

                this.getDtAllCheckedFilter = function (filters) {
                    return angular.copy(dtAllcheckedFilter);
                }

                this.getCtAllCheckedFilter = function (filters) {
                    return angular.copy(ctAllcheckedFilter);
                }

                this.getAuditFilter = function () {
                    return angular.copy(auditFilter);
                }

                this.getTYCPagination = function () {
                    return angular.copy(TYCPagination);
                }

                this.getAuditPagination = function () {
                    return angular.copy(auditPagination);
                };

                this.getContainerTypeFilter = function () {
                    return angular.copy(containerTypeFilter)
                };

                this.clearDocumentFilter = function () {
                    advancedFilter = {
                        showNoData: false,
                        DocumentTypes: [],
                        ContainerTypes: [],
                        creationDateFrom: undefined,
                        creationDateTo: undefined,
                        containerTypeId: undefined,
                        Code: '',
                        selectedDocumentTypes: [],
                        allVersion: false,
                        documentHasFiles: null,
                        documentFullText: null,
                        fromCalendar: false,
                        documentNameFilter: '',
                        documentNameType: 'EqualIgnoreCase',
                        documentFileNameFilter: '',
                        fileNameType: 'EqualIgnoreCase',
                        documentCreationDateFilterFrom: null,
                        documentCreationDateFilterTo: null,
                        selectedUser: null,
                        documentIdFilter: ''
                    };
                }

                this.clearMyDocumentFilter = function () {
                    mydocumentFilter = {
                        showNoData: false,
                        code: '',
                        documentTypes: []
                    };
                }

                this.clearMyContainerFilter = function () {
                    mycontainerFilter = {
                        Name: '',
                        showNoData: false,
                        organizationalUnitId: auth.getOrganizationId(),
                        organizationalUnitName: auth.getOrganizationName(),
                        code: '',
                        containerTypes: []
                    };
                }

                this.clearContainerFilter = function () {
                    advancedContainerFilter = {
                        showNoData: false,
                        ContainerTypes: [],
                        Id: '',
                        Name: '',
                        selectedContainerTypes: [],
                        containerNameFilter: '',
                        containerNameType: 'EqualIgnoreCase',
                        containerCreationDateFilterFrom: null,
                        containerCreationDateFilterTo: null,
                        selectedUser: null
                    };
                }

                this.clearUserFilter = function () {
                    userFilter = {
                        FirstName: '',
                        NickName: '',
                        LastName: '',
                        organizationalUnitId: auth.getOrganizationId(),
                        organizationalUnitName: auth.getOrganizationName(),
                        showNoData: false,
                        showResult: false,
                    };
                }

                this.clearCalendarFilter = function () {
                    calendarFilter = {
                        documentType: null,
                        selectedDocumentTypes: [],
                        from: null,
                        to: null,
                        view: true,
                        filterDate: null
                    };
                }

                this.clearNotifFilter = function () {
                    notifFilter = {
                        name: undefined,
                        templateName: undefined,
                        documentTypeId: undefined,
                        roleId: undefined,
                        organizationalUnitId: auth.getOrganizationId(),
                        organizationalUnitName: auth.getOrganizationName()
                    };
                }

                this.clearAuthNotifFilter = function () {
                    authNotifFilter = {
                        name: undefined,
                        templateName: undefined,
                        organizationalUnitId: auth.getOrganizationId(),
                        organizationalUnitName: auth.getOrganizationName()
                    };
                }

                this.clearSearchBarFilter = function () {
                    searchBarFilter = {
                        name: '',
                        documentIdFilter: '',
                        documentCreationDateFilterFrom: '',
                        documentCreationDateFilterTo: '',
                        selectedUser: {},
                        class: undefined,
                        classType: undefined
                    };
                }

                this.clearCtAllcheckedFilter = function () {
                    ctAllcheckedFilter = false;
                };

                this.clearDtAllcheckedFilter = function () {
                    dtAllcheckedFilter = false;
                };

                this.clearAuditFilter = function () {
                    auditFilter = {
                        user: {
                            description: {
                                userId: null
                            }
                        },
                        userId: null,
                        showNoData: false,
                        showResult: false,
                        actionType: null,
                        dateFrom: null,
                        dateTo: null,
                        auditItems: [],
                        orderBy: null,
                        organizationalUnit: {
                            id: undefined,
                            name: ''
                        },
                        currentPage: 1,
                        firstTime : true
                    };
                }

                this.clearAuditPagination = function () {
                    auditPagination = {
                        currentPage: 1,
                        totalItems: 0,
                        from: 0,
                        itemPerPage: 15
                    }
                }

                this.clearTYCPagination = function () {
                    TYCPagination = {
                        currentPage: 1,
                        totalItems: 0,
                        from: 0,
                        itemsPerPage: 15
                    }
                }
                this.clearContainerTypeFilter = function () {
                    containerTypeFilter = {
                        name: '',
                        organizationalUnitId: auth.getOrganizationId(),
                        organizationalUnitName: auth.getOrganizationName(),
                        showNoData: false,
                        app: {
                            id: 1
                        }
                    }
                };
                this.init = function () {
                    this.clearMyContainerFilter();
                    this.clearMyDocumentFilter();
                    this.clearDocumentFilter();
                    this.clearContainerFilter();
                    this.clearUserFilter();
                    this.clearCalendarFilter();
                    this.clearAuthNotifFilter();
                    this.clearNotifFilter();
                    this.clearSearchBarFilter();
                    this.clearCtAllcheckedFilter();
                    this.clearDtAllcheckedFilter();
                    this.clearAuditFilter();
                    this.clearAuditPagination();
                    this.clearTYCPagination();
                    stateBackFind = undefined;
                    this.clearContainerTypeFilter();
                }

                this.init();
            }
        ]);

})();